export const handleComponentError = (conditions, prefix = 'BTP: ') => {
  const errorIndex = conditions.findIndex((condition) => condition[0]);
  const hasError = errorIndex !== -1;

  if (!hasError) {
    return;
  }

  if (conditions[errorIndex][2]) {
    console.error(conditions[errorIndex][2]);
  }

  throw new Error(`BTP: ${conditions[errorIndex][1]}`);
};

export const placeholder = () => {
  // Required for named export lint until we add more helpers
};
